var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5988 10.365L16.6978 2.46296C15.7199 1.48795 14.3953 0.94043 13.0144 0.94043C11.6335 0.94043 10.309 1.48795 9.33111 2.46296L1.43007 10.365C1.13885 10.6544 0.907957 10.9987 0.750783 11.3779C0.593609 11.7572 0.513278 12.1639 0.514447 12.5744V22.8004C0.514447 23.6292 0.843687 24.4241 1.42974 25.0101C2.01579 25.5962 2.81064 25.9254 3.63944 25.9254H22.3894C23.2182 25.9254 24.0131 25.5962 24.5991 25.0101C25.1852 24.4241 25.5144 23.6292 25.5144 22.8004V12.5744C25.5156 12.1639 25.4353 11.7572 25.2781 11.3779C25.1209 10.9987 24.89 10.6544 24.5988 10.365ZM16.1394 23.8421H9.88944V19.7442C9.88944 18.9154 10.2187 18.1205 10.8047 17.5345C11.3908 16.9484 12.1856 16.6192 13.0144 16.6192C13.8432 16.6192 14.6381 16.9484 15.2241 17.5345C15.8102 18.1205 16.1394 18.9154 16.1394 19.7442V23.8421ZM23.4311 22.8004C23.4311 23.0767 23.3213 23.3417 23.126 23.537C22.9306 23.7324 22.6657 23.8421 22.3894 23.8421H18.2228V19.7442C18.2228 18.3629 17.674 17.0381 16.6973 16.0613C15.7205 15.0846 14.3958 14.5359 13.0144 14.5359C11.6331 14.5359 10.3083 15.0846 9.33159 16.0613C8.35484 17.0381 7.80611 18.3629 7.80611 19.7442V23.8421H3.63944C3.36318 23.8421 3.09823 23.7324 2.90288 23.537C2.70753 23.3417 2.59778 23.0767 2.59778 22.8004V12.5744C2.59874 12.2983 2.70839 12.0338 2.90299 11.8379L10.804 3.939C11.3912 3.35455 12.186 3.02644 13.0144 3.02644C13.8429 3.02644 14.6377 3.35455 15.2249 3.939L23.1259 11.8411C23.3197 12.0361 23.4293 12.2994 23.4311 12.5744V22.8004Z",
    fill: "#5B5B5B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIc);
export default __webpack_public_path__ + "static/media/home_ic.459f3aeb63d56aa9871926e98a32b388.svg";
export { ForwardRef as ReactComponent };